import React from 'react';
import { Link } from 'operation-diameter';

export default {
  title: 'Thank you for completing your application',
  paragraphs: {
    paragraph1:
      'Our team is now reviewing your application and will be in touch either by phone or email typically within the next 24 hours.',
    paragraph2: () => (
      <>
        You can now close this window or return to the{' '}
        <Link href='https://www.fundingcircle.com/uk' isExternal>
          homepage.
        </Link>
      </>
    )
  }
};
